import { request, queryString } from '../../util'

const headers = { 'Content-Type': 'application/json' }
const url = '/private/api/fvp/payrolls'
const timesheetUrl = '/private/api/fvp/payrolls/timesheet'
const employeeTimesheetUrl = '/private/api/fvp/payrolls/employee'
const clientTimesheetUrl = '/private/api/fvp/payrolls/client'

export default {
  add (values) {
    return request(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  },
  get (id) {
    return request(`${url}/${id}`)
  },
  remove (id) {
    return request(`${url}/${id}`, {
      method: 'DELETE',
      headers
    })
  },
  save (id, values) {
    return request(`${timesheetUrl}/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(values)
    })
  },

  listByPage (page, size, filter, sorting, text) {
    return request(`${url}/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  listTimesheetByPage (page, size, filter, sorting, text, view) {
    return request(`${timesheetUrl}/${view}/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  getTimesheetSummary (id, view) {
    return request(`${timesheetUrl}/${view}/${id}/summary`)
  },
  listEmployeeTimesheetByPage (page, size, filter, sorting, text) {
    return request(`${employeeTimesheetUrl}/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  getEmployeeTimesheetSummary (id, eid) {
    return request(`${employeeTimesheetUrl}/${eid}/timesheet/${id}/summary`)
  },
  listClientTimesheetByPage (page, size, filter, sorting, text) {
    return request(`${clientTimesheetUrl}/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  getClientTimesheetSummary (id, eid) {
    return request(`${clientTimesheetUrl}/${eid}/timesheet/${id}/summary`)
  },
  listStatusTimesheetByPage (status, page, size, filter, sorting, text) {
    return request(`${url}/${status}/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  getStatusTimesheetSummary (status, id) {
    return request(`${url}/${status}/${id}/timesheet/summary`)
  },
  downloadInvoice (id) {
    return request(`${url}/export/invoice/payroll/${id}`)
  },
  generate (from, to) {
    return request(`${url}/${from}/${to}`)
  }
}
